<div class="contact-wrapper" [ngClass]="{'page-wrapper': page}">

    <div *ngIf="showContacts">

        <div class="white-wrapper">
            <a href="tel:{{CONTACT_PHONE}} "  class="login-logo">
                <img class="login-logo" src="assets/images/icons/social/call_contact.svg" alt="contact logo">

            </a>

        </div>


        <div>
            <img class="login-logo" src="assets/images/icons/viber-contact.svg" alt="contact logo" (click)="openUrl()">
        </div>

        <div>
            <img class="login-logo" src="../../../assets/images/icons/telegran-contact.svg" alt="contact logo"
                 (click)="openUrl()">
        </div>

        <div (click)="toggleContacts()">
            <img class="login-logo" src="assets/images/icons/closed-contact.svg" alt="contact logo">
        </div>

    </div>


    <div (click)="toggleContacts()" *ngIf="!showContacts">
        <img class="login-logo show-contacts" src="assets/images/icons/contact.svg" alt="contact logo">
    </div>

</div>
